module.exports = __webpack_public_path__ + "static/giovanna-pedroni-104c3f09d1c27228940307d28aefa67b.jpg";